var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:cancel-bold"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.8337 7.198L17.8024 4.16675L12.5003 9.46883L7.19824 4.16675L4.16699 7.198L9.46908 12.5001L4.16699 17.8022L7.19824 20.8334L12.5003 15.5313L17.8024 20.8334L20.8337 17.8022L15.5316 12.5001L20.8337 7.198Z",
    fill: "#545454"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.06f560f7dff5f96f6d5d720d4b9db643.svg";
export { ForwardRef as ReactComponent };